import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SelectController from "../../reusableComponents/SelectController";
import myBackgroundImage from "../../../assets/images/Designer.png";
import baseURL from "./../../authComponents/baseURL/BaseURL"

const HeroScreen = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    gender: "",
    marital_Status: "",
    religion: "",
    occupation: "",
    country: "",
    division: "",
    city: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchBtnTxt, setSearchBtnText] = useState("See All Profiles")

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
  
    const updatedFormData = {
      ...formData,
      [name]: value,
    };
  
    setFormData(updatedFormData);
  
    if (
      updatedFormData["marital_Status"] !== '' ||
      updatedFormData["gender"] !== '' ||
      updatedFormData["religion"] !== '' ||
      updatedFormData["occupation"] !== ''
    ) {
      setSearchBtnText("See Profiles");
    } else {
      setSearchBtnText("See All Profiles");
    }

  };
  

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const convertToUrlParams = (data) => {
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([_, v]) => v !== "" && v !== null)
    );

    const urlParams = new URLSearchParams(filteredData);
    return urlParams.toString();
  };

  const handleApplyFilters = () => {
    const params = convertToUrlParams(formData);
    const queryString = params ? `?${params}` : "";
    const fetchUrl = `${baseURL}/profiles`;
    const naviagtionURL = queryString ? `/all-profiles${queryString}&searchType=local` : `/all-profiles`
    navigate(naviagtionURL);
  };

  const selectOptions = [
    {
      label: "I am looking for",
      name: "gender",
      options: [
        { value: "", label: "Any Gender" },
        { value: "female", label: "Woman" },
        { value: "male", label: "Man" },
      ],
    },
    {
      label: "Marital Status",
      name: "marital_Status",
      options: [
        { value: "", label: "Any Status" },
        { value: "single", label: "Single" },
        { value: "divorced", label: "Divorced" },
        { value: "separated", label: "Separated" },
        { value: "widow", label: "Widow (Husband Died)" },
        { value: "widower", label: "Widower (Wife Died)" },
      ],
    },
    {
      label: "Religion",
      name: "religion",
      options: [
        { value: "", label: "Any Religion" },
        { value: "islam", label: "Islam" },
        { value: "christianity", label: "Christianity" },
        { value: "hinduism", label: "Hinduism" },
        { value: "buddhism", label: "Buddhism" },
        { value: "sikhism", label: 'Sikhism'},
        { value: "jainism", label: "Jainism"}, 
        { value: "bahai", label: "Baháʼí Faith"}, 
        { value: "zoroastrianism", label: "Zoroastrianism"}, 
        { value: "confucianism", label: "Confucianism"}, 
        { value: "taoism", label: "Taoism" },
        { value: "spiritism", label: "Spiritism"}
      ],
    },
    {
  label: "Profession",
  name: "occupation",
  options: [
    { value: "", label: "Any Profession" },
    { value: "accountant", label: "Accountant" },
    { value: "acting_professional", label: "Acting Professional" },
    { value: "actor_actress", label: "Actor / Actress" },
    { value: "administration_professional", label: "Administration Professional" },
    { value: "advertising_visualiser", label: "Advertising Visualiser" },
    { value: "air_hostess", label: "Air Hostess" },
    { value: "architect", label: "Architect" },
    { value: "artist", label: "Artist" },
    { value: "audiologist", label: "Audiologist" },
    { value: "banker", label: "Banker" },
    { value: "beautician", label: "Beautician" },
    { value: "biologist", label: "Biologist" },
    { value: "botanist", label: "Botanist" },
    { value: "chartered_accountant", label: "Chartered Accountant" },
    { value: "civil_engineer", label: "Civil Engineer" },
    { value: "clerical_official", label: "Clerical Official" },
    { value: "commercial_pilot", label: "Commercial Pilot" },
    { value: "company_secretary", label: "Company Secretary" },
    { value: "computer_professional", label: "Computer Professional" },
    { value: "consultant", label: "Consultant" },
    { value: "contractor", label: "Contractor" },
    { value: "cost_accountant", label: "Cost Accountant" },
    { value: "creative_person", label: "Creative Person" },
    { value: "customer_support_professional", label: "Customer Support Professional" },
    { value: "dentist", label: "Dentist" },
    { value: "designer", label: "Designer" },
    { value: "doctor", label: "Doctor" },
    { value: "economist", label: "Economist" },
    { value: "engineer", label: "Engineer" },
    { value: "entertainment_professional", label: "Entertainment Professional" },
    { value: "executive", label: "Executive" },
    { value: "factory_worker", label: "Factory Worker" },
    { value: "farmer", label: "Farmer" },
    { value: "fashion_designer", label: "Fashion Designer" },
    { value: "finance_professional", label: "Finance Professional" },
    { value: "flight_attendant", label: "Flight Attendant" },
    { value: "government_employee", label: "Government Employee" },
    { value: "health_care_professional", label: "Health Care Professional" },
    { value: "home_maker", label: "Home Maker" },
    { value: "hotel_restaurant_professional", label: "Hotel / Restaurant Professional" },
    { value: "interior_designer", label: "Interior Designer" },
    { value: "investment_professional", label: "Investment Professional" },
    { value: "it_telecom_professional", label: "IT / Telecom Professional" },
    { value: "journalist", label: "Journalist" },
    { value: "lawyer_legal_professional", label: "Lawyer / Legal Professional" },
    { value: "manager", label: "Manager" },
    { value: "marketing_professional", label: "Marketing Professional" },
    { value: "media_professional", label: "Media Professional" },
    { value: "medical_professional", label: "Medical Professional" },
    { value: "military", label: "Military" },
    { value: "not_working", label: "Not Working" },
    { value: "nurse", label: "Nurse" },
    { value: "odd_jobs_part_time", label: "Odd Jobs / Part Time" },
    { value: "online_merchant", label: "Online Merchant" },
    { value: "optician", label: "Optician" },
    { value: "pharmacist", label: "Pharmacist" },
    { value: "physicist", label: "Physicist" },
    { value: "physiotherapist", label: "Physiotherapist" },
    { value: "pilot", label: "Pilot" },
    { value: "politician", label: "Politician" },
    { value: "professor_teacher", label: "Professor / Teacher" },
    { value: "psychologist", label: "Psychologist" },
    { value: "public_relations_professional", label: "Public Relations Professional" },
    { value: "real_estate_professional", label: "Real Estate Professional" },
    { value: "research_scholar", label: "Research Scholar" },
    { value: "retired_person", label: "Retired Person" },
    { value: "sales_professional", label: "Sales Professional" },
    { value: "scientist", label: "Scientist" },
    { value: "self_employed", label: "Self-Employed" },
    { value: "social_worker", label: "Social Worker" },
    { value: "software_consultant", label: "Software Consultant" },
    { value: "sports_athlete", label: "Sports / Athlete" },
    { value: "student", label: "Student" },
    { value: "teacher", label: "Teacher" },
    { value: "technician", label: "Technician" },
    { value: "training_professional", label: "Training Professional" },
    { value: "unspecified", label: "Unspecified" },
    { value: "veterinary_doctor", label: "Veterinary Doctor" },
    { value: "volunteer", label: "Volunteer" },
    { value: "writer", label: "Writer" },
    { value: "zoologist", label: "Zoologist" },
  ],
}
  ];

  return (
    <div
      className="relative w-full min-h-screen bg-cover bg-center md:bg-left-top flex flex-col"
      style={{
        backgroundImage: `url(${myBackgroundImage})`,
      }}
    >
      <div className="text-start p-20 py-10 mt-10 max-md:pt-20 max-md:p-5 flex flex-col max-md:mb-0 text-white">
        <h1 className="text-3xl md:text-6xl font-bold">Welcome</h1>
        <p className="text-md md:text-xl md:w-[25%] mt-4 max-md:mt-2">
          Meet your perfect match on our app, the top choice among matrimonial
          sites in Pakistan. Search for your compatible match effortlessly
          across countries.
        </p>
      </div>

      <div className="md:hidden flex justify-center mt-4">
        <button
          onClick={toggleModal}
          className="bg-[#730000] text-white py-2 px-6 rounded-lg hover:bg-[#730000] transition duration-300"
        >
          {isModalOpen ? "Close Filters" : "Find Your Match"}
        </button>
      </div>

      {/* New bottom section for filters */}
      <div className="hidden md:flex justify-center max-lg:flex-wrap">
        <div className="w-[80%] max-lg:w-[100%] grid grid-cols-5 max-lg:grid-cols-4 gap-3 items-center p-4 rounded-lg">
          {selectOptions.map((selectData) => (
            <SelectController
              key={selectData.name}
              label={selectData.label}
              options={selectData.options}
              value={formData[selectData.name]}
              onChange={handleSelectChange}
              name={selectData.name}
            />
          ))}

          <div className="pt-6 flex">
            <button
              onClick={handleApplyFilters}
              className="w-40 bg-[#730000] text-white py-2 rounded-lg hover:bg-[#730000] transition duration-300"
            >
              {searchBtnTxt}
            </button>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black overflow-scroll p-8 bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-full overflow-y-scrol p-2">
            <div className="flex justify-between items-center border-b pb-2 mb-4">
              <h2 className="text-xl font-bold">Search Your Partner</h2>
              <button
                onClick={toggleModal}
                className="text-gray-500 hover:text-[#730000] transition"
              >
                ✕
              </button>
            </div>

            <div className="grid grid-cols-2 text-[10px] gap-1">
              {selectOptions.map((selectData) => (
                <SelectController
                  key={selectData.name}
                  label={selectData.label}
                  options={selectData.options}
                  value={formData[selectData.name]}
                  onChange={handleSelectChange}
                  name={selectData.name}
                />
              ))}
            </div>

            <div className="flex justify-center text-sm mt-6">
              <button
                onClick={() => {
                  handleApplyFilters();
                  toggleModal();
                }}
                className="w-full bg-[#730000] text-white py-2 rounded-lg hover:bg-[#730000] transition duration-300"
              >
                Search Your Partner
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeroScreen;
